export const checkSignUpData = (fullName, email, password) => {
  const isFullNameValid = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/.test(
    fullName
  );

  const isEmailValid = /^[\w\-.]+@([\w-]+.)+[\w-]{2,}$/.test(email);

  const isPasswordValid =
    /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/.test(password);

  if (!isFullNameValid) return "Name can have only letters - ' , space";

  if (!isEmailValid) return "Try using the format yourname@email.com";

  if (!isPasswordValid) return "Password must be min 8 characters, min 1 uppercase letter, 1 special character, and 1 numeric digit."

  return null;
};

export const checkSignInData = (email, password) => {
  const isEmailValid = /^[\w\-.]+@([\w-]+\.)+[\w-]{2,}$/.test(email);
  const isPasswordValid =
    /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/.test(password);
    if (!isEmailValid) return "Try using the format yourname@email.com";

    if (!isPasswordValid) return "Password must be at min 8 characters, min 1 uppercase letter, 1 special character, and 1 numeric digit."

  return null;
  
};
